export default {
  title: "Blog",
  sections: {
    blogs_hero_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/blog_bg.jpg',
            image_mobile: '/seu/blog_mobile_bg.jpg',
            text: 'The SEU blog',
            text2: 'News and topics of interest to knowledge-seeking engineers, planners and geomatics specialists',
            text3: 'Stay informed: Receive new posts as a newsletter',
            placeholder: 'Enter you email',
            buttonLabel: 'Subscribe'
          }
        },
      }
    },
  }
}
